module.exports = __webpack_public_path__ + "69788120773216f168bc641cc2cca0e4.png";